import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from '../../customer/src/app/app.config';
import { AppComponent } from '../../customer/src/app/app.component';
import { environment } from './app/environments/environment';

const bigIdScript = document.createElement('script');
bigIdScript.src = `https://bigidcmp.cloud/banner.js?siteId=${environment.bigIdSiteId}`;
bigIdScript.async = false;
document.head.appendChild(bigIdScript);

if (environment.bigIdConsentConfig) {
  (window as any).BigIDConsentConfig = environment.bigIdConsentConfig;
  const eventsScript = document.createElement('script');
  eventsScript.src = 'https://www.kemper.com/sites/default/files/scripts/common/bigid-events.js';
  eventsScript.async = false;
  document.head.appendChild(eventsScript);
}

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
